import { render } from "./SettlementDetailsModal.vue?vue&type=template&id=55af40ab&scoped=true"
import script from "./SettlementDetailsModal.vue?vue&type=script&lang=js"
export * from "./SettlementDetailsModal.vue?vue&type=script&lang=js"

import "./SettlementDetailsModal.vue?vue&type=style&index=0&id=55af40ab&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55af40ab"]])

export default __exports__